import axios, { AxiosRequestConfig } from "axios";
import { getCookie } from "utils/setCookie";
import { ClubDetail } from "../interface";

export const getListClub = async (): Promise<any[]> => {
  const url = process.env.REACT_APP_AJAX_URL + "group/list?order_by=DESC";
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };
    const response = await axios.post(url, {}, axiosConfig);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch group data");
  }
};

export const getDetailClub = async (id: string): Promise<ClubDetail> => {
  const url = process.env.REACT_APP_AJAX_URL + `group/detail/${id}`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };
    const response = await axios.get(url, axiosConfig);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch group data");
  }
};

export const createClub = async (
  name: string,
  cover: string,
  description: string,
  isEliteClub: boolean,
  skills: string[],
  featured_image: string[],
  location: string
): Promise<any> => {
  const requestData = {
    name,
    cover,
    description,
    isEliteClub,
    skills,
    featured_image,
    location,
  };
  const axiosConfig: AxiosRequestConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  const url = process.env.REACT_APP_AJAX_URL + "group/create";
  return axios.post(url, requestData, axiosConfig);
};

let uploadTimeout: NodeJS.Timeout;

export const uploadMedia = async (
  file: File,
  headers: AxiosRequestConfig["headers"]
): Promise<any> => {
  const TIMEOUT_DURATION = 30 * 60 * 1000;

  try {
    const formData = new FormData();
    formData.append("file[]", file);

    const config: AxiosRequestConfig = {
      method: "post",
      url: `${process.env.REACT_APP_AJAX_UPLOAD_URL_BASE}/upload-file?callback=${process.env.REACT_APP_AJAX_URL}media/create`,
      headers,
      data: formData,
      timeout: TIMEOUT_DURATION,
    };

    uploadTimeout = setTimeout(() => {
      console.error("Upload timed out");
      throw new Error("Upload timed out");
    }, TIMEOUT_DURATION);

    const response = await axios.request(config);

    clearTimeout(uploadTimeout);

    if (
      response.data &&
      response.data[0] &&
      response.data[0].callback &&
      response.data[0].callback._id &&
      response.data[0].src
    ) {
      return { id: response.data[0].callback._id, src: response.data[0].src };
    } else {
      throw new Error("Upload failed: Invalid response");
    }
  } catch (error) {
    clearTimeout(uploadTimeout);
    throw new Error(`Upload failed: ${error.message}`);
  }
};

export const updateClub = async (
  _id: string,
  name: string,
  cover: string,
  description: string,
  isEliteClub: boolean,
  skills: string[],
  featured_image: string[],
  location: string
): Promise<any> => {
  const requestData = {
    _id,
    name,
    cover,
    description,
    isEliteClub,
    skills,
    featured_image,
    location,
  };
  const axiosConfig: AxiosRequestConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  const url = process.env.REACT_APP_AJAX_URL + "group/admin-update";
  return axios.patch(url, requestData, axiosConfig);
};

export const deleteClub = async (group_id: string): Promise<any> => {
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session") || "",
    },
  };

  const url = `${process.env.REACT_APP_AJAX_URL}group/delete/${group_id}`;

  try {
    const response = await axios.delete(url, axiosConfig);
    return response.data;
  } catch (error) {
    console.error("Error deleting post:", error);
    throw error;
  }
};
